import { render, staticRenderFns } from "./RollbackSelector.vue?vue&type=template&id=1539c689&"
import script from "./RollbackSelector.vue?vue&type=script&lang=js&"
export * from "./RollbackSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports